module.exports = __webpack_public_path__ + "img/4.5040a195.jpg";